import { useFeatureFlagStore } from "@/store/useFeatureFlagStore";

/**
 * Get the boolean value of a feature flag from the environment.
 * Flags should be set with ENV variable: `VITE_FEATURE_$=TRUE`
 * Where $ is the name of the feature.
 *
 * When `throwOnMissing` is true, a missing flag will throw error.
 * If false, the feature will be considered disabled if flag is missing.
 */
export function useFeatureFlag(featureName: string, throwOnMissing = false) {
	const store = useFeatureFlagStore();
	return store.get(featureName, throwOnMissing);
}
